import { render } from "./singleProductView.vue?vue&type=template&id=5a133658&scoped=true"
import script from "./singleProductView.vue?vue&type=script&lang=js"
export * from "./singleProductView.vue?vue&type=script&lang=js"

import "./singleProductView.vue?vue&type=style&index=0&id=5a133658&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a133658"]])

export default __exports__